module.exports = __webpack_public_path__ + "img/dashboard-share.e2081a5b.png";